import Modal from 'react-modal';

import { Container, Actions } from "./styled";

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: "white",
        padding: "0px",
        margin: "0px"
    },
    overlay: {
        backgroundColor: "rgba(10,23,55,0.5)",
        zIndex: "99999999"
    }
};

const ModalInforVideo = (props) => {

    return (
        <Modal
            isOpen={props.visible}
            style={customStyles}
            ariaHideApp={false}
            onRequestClose={() => props?.setVisibleModal(false)}
        >
            <Container>
                <iframe
                    width={window.innerWidth - 300}
                    height={(window.innerWidth - 300) / 2}
                    src={props.video}
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen = "false"
                    referrerPolicy="strict-origin-when-cross-origin" />
            </Container>

        </Modal>
    )
}

export default ModalInforVideo
